<template>
  <div>
    <!-- eslint-disable-next-line vue/no-v-html -->
    <div @click="handleClick" v-html="$sanitize(currentPage.content)" />
    <div v-if="surveyLinks.length" class="row justify-content-center">
      <div class="col-6">
        <router-link
          v-for="link in surveyLinks"
          :key="link.apiId"
          :to="{name: 'survey', params: {api_id: link.api_id}}"
          class="btn btn-primary btn-block"
        >
          {{ link.name }}
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex';
  import store from '../../store';

  export default {

    name: "DashboardApp",
    async beforeRouteEnter(to, from, next) {
      await store.dispatch('LOAD_ARM');
      // if they somehow got here but their arm doesn't have the portal enabled,
      // send them back to enrollment
      if (!store.getters.isArmWithPortal) {
        next({name: 'enrollment'});
      }
      try {
        await store.dispatch('LOAD_PAGE', to.params.path || '/');
        await store.dispatch('LOAD_NOTIFICATIONS');
      } catch (e) {
        if (e.message === 'PAGE_DOES_NOT_EXIST') {
          // this will accommodate bad urls as well as if for some reason the homepage got deleted
          return next({name: '404', replace: true});
        }
      }
      next();
    },
    async beforeRouteUpdate (to, from, next) {
      try {
        await store.dispatch('LOAD_PAGE', to.params.path || '/');
        await store.dispatch('LOAD_NOTIFICATIONS');
      } catch (e) {
        if (e.message === 'PAGE_DOES_NOT_EXIST') {
          // this will accommodate bad urls as well as if for some reason the homepage got deleted
          return next({name: '404', replace: true});
        }
      }
      next();
    },
    computed: mapState(['currentPage', 'surveyLinks']),
    methods: {
      handleClick(e) {
        var anchor = e.target.closest('a');
        if (anchor && anchor.matches('[data-portal-page]')) {
          e.preventDefault();
          this.loadNewPage(anchor);
        }
      },
      loadNewPage(anchor) {
        let path = anchor.getAttribute('data-portal-page');
        this.$router.push({ path: `/dashboard${path}`});
      },
    }
  }
</script>

<style scoped>
  >>> img {
    max-width: 100%;
    height: auto !important;
  }
</style>
